import { __extends } from "tslib";
import { BitmapFilter } from './BitmapFilter';
import { toNumber, isNullOrUndefined } from '@awayfl/swf-loader';
import { Errors } from '@awayfl/avm2';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: ColorMatrixFilter
var ColorMatrixFilter = /** @class */ (function (_super) {
    __extends(ColorMatrixFilter, _super);
    function ColorMatrixFilter(matrix) {
        if (matrix === void 0) { matrix = null; }
        var _this = _super.call(this) || this;
        if (matrix) {
            _this.matrix = matrix;
        }
        else {
            _this._matrix = [
                1, 0, 0, 0, 0,
                0, 1, 0, 0, 0,
                0, 0, 1, 0, 0,
                0, 0, 0, 1, 0
            ];
        }
        return _this;
    }
    ColorMatrixFilter.FromUntyped = function (obj) {
        var filter = Object.create(ColorMatrixFilter.axClass.tPrototype);
        filter._matrix = obj.matrix;
        return filter;
    };
    ColorMatrixFilter.prototype._serialize = function (message) {
        var matrix = this._matrix;
        message.ensureAdditionalCapacity((matrix.length + 1) * 4);
        message.writeIntUnsafe(6);
        for (var i = 0; i < matrix.length; i++) {
            message.writeFloatUnsafe(matrix[i]);
        }
    };
    Object.defineProperty(ColorMatrixFilter.prototype, "matrix", {
        get: function () {
            return this.sec.createArrayUnsafe(this._matrix.concat());
        },
        set: function (value_) {
            if (isNullOrUndefined(value_)) {
                this.sec.throwError('TypeError', Errors.NullPointerError, 'matrix');
            }
            var matrix = [
                0, 0, 0, 0, 0,
                0, 0, 0, 0, 0,
                0, 0, 0, 0, 0,
                0, 0, 0, 0, 0
            ];
            var value = value_.value;
            for (var i = 0, n = Math.min(value.length, 20); i < n; i++) {
                matrix[i] = toNumber(value[i]);
            }
            this._matrix = matrix;
        },
        enumerable: true,
        configurable: true
    });
    ColorMatrixFilter.prototype.clone = function () {
        return new ColorMatrixFilter(this.matrix);
    };
    ColorMatrixFilter.classInitializer = null;
    return ColorMatrixFilter;
}(BitmapFilter));
export { ColorMatrixFilter };
